/* eslint-disable complexity */
import { legendOrderSortFunction } from '../../../services/utilities/utilities';
import { OWS_TYPE, NG_LAYER_TYPES } from '../../../constants';


export function legendData(selectedLayers) {
    const displayLayers = selectedLayers
        .map(({ id, active, type, data, hidePolygonFill }) => {
            const hasStyles = data.styles && data.styles.length > 0;
            const hasCustomStyles = hasStyles && data.styles[0].customStylingOptions !== null;

            const isWFSWithoutGraphicalLayer = (type === NG_LAYER_TYPES.CUSTOM && data.serviceType !== OWS_TYPE.WMS) ||
                (data.serviceType === OWS_TYPE.WFS && (data.graphicalLayerName === undefined || data.graphicalLayerName === null));

            let isCssObject = hasStyles && isWFSWithoutGraphicalLayer && !hasCustomStyles;
            const isCustomCssObject = hasStyles && isWFSWithoutGraphicalLayer && hasCustomStyles;

            let isImageObject = !isCssObject && !isCustomCssObject && hasStyles && data.title;
            const legendImageURL = isImageObject ? data.customEndPoints.legend?.url : null;
            const legendExpanded = data.legendExpanded || type === 'feedback';

            // Add hidePolygonFill info, default false
            const hideFill = hidePolygonFill || false;

            if (data.geometryType === 'V' && data.graphicalLayerName && isImageObject && hideFill) {
                isImageObject = false;
                isCssObject = true;
            }

            return {
                id,
                title: data.title,
                geometryType: data.geometryType,
                styles: data.styles,
                feedback: type === 'feedback',
                active,
                isCssObject,
                isCustomCssObject,
                isImageObject,
                legendImageURL,
                sortOrder: data.sortOrder,
                legendExpanded,
                hideFill,
                infoUrl: data.infoUrl,
                infoLinkType: data.infoLinkType,
                metadataUrl: data.metadataUrl,
                styleServiceUrl: data.serviceType === OWS_TYPE.OGCT ? data.serviceUri : null
            };
        })
        .filter(({ isCssObject, isCustomCssObject, isImageObject }) => isCssObject || isCustomCssObject || isImageObject);
    return displayLayers.sort(legendOrderSortFunction);
}
